module.exports = __webpack_public_path__ + "img/workContents01_pc_05.8fe90e75.png";